import type {ReactElement} from 'react';
import {SurveyFieldKind} from '@Components/ai-chat-window/components/survey/survey.types';
import type {FieldRendererProps} from './fields.types';
import {TextFieldRenderer} from './text-field';
import {SelectFieldRenderer} from './select-field';
import {MultiSelectFieldRenderer} from './multiselect-field';

export function FieldRenderer({step}: FieldRendererProps): ReactElement | null {
  const name = step.key;
  switch (step.field.kind) {
    case SurveyFieldKind.TEXT:
      return <TextFieldRenderer name={name} step={step} field={step.field} />;
    case SurveyFieldKind.SELECT:
      return <SelectFieldRenderer name={name} step={step} field={step.field} />;
    case SurveyFieldKind.MULTISELECT:
      return <MultiSelectFieldRenderer name={name} step={step} field={step.field} />;
    default:
      return null;
  }
}
